export enum DEVICE_TYPE {
    ANDROID_NOT_COMPATIBLE = "ANDROID_NOT_COMPATIBLE",
    BROWSER_COMPATIBLE = "BROWSER_COMPATIBLE",
    DESKTOP = "DESKTOP",
    DESKTOP_NOT_COMPATIBLE = "DESKTOP_NOT_COMPATIBLE",
    IOS = "IOS",
    IPAD = "IPAD",
    TABLET = "TABLET",
}
